import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subject, takeUntil } from 'rxjs';
import { MomentPipe } from '../../../pipes/moment.pipe';
import { StripeService } from '../../../services/stripe.service';

@Component({
  selector: 'app-result',
  standalone: true,
  imports: [MomentPipe],
  templateUrl: './result.component.html',
  styleUrl: './result.component.css',
})
export class ResultComponent {
  router = inject(Router);
  route: ActivatedRoute = inject(ActivatedRoute);
  logger = inject(NGXLogger);
  stripeService = inject(StripeService);

  groupId: string | null = null;

  subscription: any | null = null;

  exit$: Subject<void> = new Subject<void>();
  setupIntent: string | null = null;
  setupIntentClientSecret: string | null = null;
  redirectStatus: string | null = null;

  // http://localhost:4200/school/kJwzG54osQL0g0plEIj5/billing/success?
  // setup_intent=seti_1SYBgiKnmvBguOL98IjOgw9E
  // &
  // setup_intent_client_secret=seti_1SYBgiKnmvBguOL98IjOgw9E_secret_TVC4DZd2KzmAiWjcFzlrG7MPjqC41FV
  // &
  // redirect_status=succeeded

  constructor() {
    this.route.queryParamMap
      .pipe(takeUntil(this.exit$))
      .subscribe(async (params) => {
        this.groupId = params.get('groupId');
        this.setupIntent =
          this.route.snapshot.queryParamMap.get('setup_intent');
        this.setupIntentClientSecret = this.route.snapshot.queryParamMap.get(
          'setup_intent_client_secret'
        );
        this.redirectStatus =
          this.route.snapshot.queryParamMap.get('redirect_status');

        if (this.setupIntent && this.redirectStatus === 'succeeded') {
          this.subscription =
            await this.stripeService.getSubscriptionFromSetupIntent(
              this.setupIntent
            );
          this.logger.debug(
            'Retrieved subscription:',
            JSON.stringify(this.subscription)
          );
        }
      });
  }

  goToDashboard() {
    this.router.navigate([`/school/${this.groupId}/billing`]);
  }
}
